import { useContext, useState } from "react";
import Button from "../../components/ui/Button";
import { ContactContext } from "../../store/context/ContactContext";
import { ReactComponent as SpinningCircleIcon } from "../../assets/svg/spinning-circle.svg";

function EmailSubscriptionBox() {
  const { emailInput, setEmailInput, submitSubscribersForm, loading } =
    useEmailSubscriptionBox();
  return (
    <div className="bg-praying-man bg-cover w-full p-6 min-h-[200px] flex flex-col justify-center gap-4 text-white">
      <p className="text-lg font-semibold">Subscribe to our prayer list</p>
      <form
        onSubmit={submitSubscribersForm}
        className="bg-white max-w-md flex justify-stretch items-center rounded-md overflow-hidden"
      >
        <input
          type="email"
          value={emailInput}
          onChange={(e) => setEmailInput(e.target.value)}
          required
          name="email"
          className="text-dark p-2 outline-none w-full min-w-[200px]"
          placeholder="Enter Your Email Address"
        />
        {loading ? (
          <Button disabled className="px-8 pointer-events-none">
            <SpinningCircleIcon />
          </Button>
        ) : (
          <Button className="tracking-widest px-8">SUBSCRIBE</Button>
        )}
      </form>
      <small>Get the words of the spirit to enlighten your day.</small>
    </div>
  );
}

export default EmailSubscriptionBox;

// ??_________________________ CONTROLLER ____________________ ?? //
export const useEmailSubscriptionBox = () => {
  const [emailInput, setEmailInput] = useState<string>("");
  const { handleSubmitSubscribersForm, loading } = useContext(ContactContext);

  const submitSubscribersForm = (e: React.FormEvent) => {
    e.preventDefault();
    handleSubmitSubscribersForm(emailInput);
    setEmailInput("");
  };

  return { emailInput, setEmailInput, submitSubscribersForm, loading };
};
